import React from 'react';
import { CouponValueTypeEnum } from '../../../../api/payments/coupons/domain/enum';
import { useTweenedNumber } from '../../../../hooks/useTweenedNumber';

function formatToCurrency(value) {
  return Number(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

export function DiscountPricePreview({ plan, valueType, value, hideLabel }) {
  const originalPrice = Number(plan?.price ?? plan?.amount ?? plan?.value);
  const discountValue = Number(value);
  const valid =
    !!plan &&
    value !== '' &&
    value !== null &&
    value !== undefined &&
    Number.isFinite(originalPrice) &&
    Number.isFinite(discountValue);

  const rawPrice =
    valueType === CouponValueTypeEnum.PERCENT
      ? originalPrice * (1 - discountValue / 100)
      : originalPrice - discountValue;
  // NaN enquanto inválido: o hook não anima e o preview nem renderiza.
  const finalPrice = useTweenedNumber(valid ? Math.max(0, rawPrice) : NaN);

  if (!valid) return null;

  return (
    <div
      className="d-flex align-items-center jds-enter"
      style={{ gap: 'var(--space-8)', marginTop: 'var(--space-8)', flexWrap: 'wrap' }}
    >
      <span
        className="text-muted"
        style={{ textDecoration: 'line-through' }}
      >
        {formatToCurrency(originalPrice)}
      </span>
      <span className="jds-title-sm" style={{ color: 'var(--fg-brand-strong)' }}>
        {formatToCurrency(finalPrice)}
      </span>
      {!hideLabel && (
        <span className="text-muted">
          preço de "{plan.name}" com o desconto aplicado
        </span>
      )}
    </div>
  );
}
